<template>
    <ValidationProvider
        :vid="vid"
        :rules="rules"
        :name="label"
        v-slot="{ errors }"
        tag="div"
        class="form-group"
        :class="{ 'form-group-compact': compact, 'mb-0': noBottomMargin }"
    >
        <label v-if="label && !hideLabel">{{ label }}<span v-if="required" class="text-danger">*</span></label>
        <div class="input-group">
            <div v-if="$slots['input-group-prepend']" class="input-group-prepend">
                <slot name="input-group-prepend"></slot>
            </div>
            <component
                :is="component"
                :label="optionLabel"
                :placeholder="placeholder ? placeholder : label"
                v-model="valle"
                @input="handleInput"
                :disabled="disabled"
                :reduce="reduce"
                :clearable="clearable"
                :class="{ 'has-validation-error': (errors.length > 0) }"
                :options="options"
                v-bind="$attrs"
                v-on="$listeners"
            />
            <div v-if="$slots['input-group-append']" class="input-group-append">
                <slot name="input-group-append"></slot>
            </div>
        </div>
        <span class="validation-invalid-label">{{ getInvalidFeedback(errors) }}</span>
    </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import VueSelect from '@components/Wrappers/VueSelect';

export default {
    name: 'SelectWithValidation',
    props: {
        vid: {
            type: String,
            default: null,
        },
        rules: {
            type: [String, Object, Array],
            default: '',
        },
        value: null,
        label: {
            type: String,
            default: null,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
        optionLabel: {
            type: String,
            default: 'label',
        },
        placeholder: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        component: {
            type: String,
            default: 'VueSelect',
        },
        reduce: {
            type: Function,
            default: (opt) => opt,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        options: {
            type: Array,
            default: null,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        noBottomMargin: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ValidationProvider,
        VueSelect,
    },
    data: () => ({
        valle: null,
    }),
    watch: {
        value(val) {
            this.valle = val;
        },
    },
    created() {
        this.valle = this.value;
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        getInvalidFeedback(errors, key = null) {
            if (key) {
                if (Array.isArray(errors[key]) && errors[key].length) {
                    return errors[key].join(', ');
                }
            }

            if (Array.isArray(errors) && errors.length) {
                return errors.join(', ');
            }

            return null;
        },
    },
    computed: {
        required() {
            if (this.rules instanceof Object) {
                return this.rules.required ?? false;
            }
            return this.rules.includes('required');
        },
    },
};
</script>

<style>
.form-group.form-group-compact {
    margin-bottom: 0.625rem;
}
.form-group.form-group-compact .col-form-label, .form-group.form-group-compact label {
    margin-bottom: 0.25rem;
}
</style>
